.user,
.externalUser {
  font-size: var(--font-size-6);
  pointer-events: none;
  position: relative;
}

.externalUser {
  align-items: center;
  display: flex;
  font-size: var(--font-size-7);
  font-style: italic;
  line-height: var(--line-size-7);
  position: relative;
}

.externalUser svg {
  display: inline-block;
  font-size: var(--font-size-7);
  height: 20px;
  margin: 0 var(--space-small);
  width: 20px;
}
